import styled from "styled-components";

import { Contract } from "../../types";
import { Typography } from "../atoms/Typography";
import { PdtIcon } from "../atoms/PdtIcon";
import { Tooltip } from "../atoms/Tooltip";
import {
  DataTable,
  DataListSimpleHeader,
  DataListBody,
  DataListRow,
  DataListBodyItem,
} from "../atoms/Table";
import { Button } from "../atoms/Button";

/**
 * ContractManagerList Component
 */
type ContractManagerListProps = {
  contracts: Contract[];
  onManagerClick: (contractId: string) => void;
};

const flexRatio = [0.3, 1, 1, 2.2, 1, 1];

const headerTitles = [
  "製品",
  "名前",
  "部署",
  "メールアドレス",
  "Welcomeメール送信日",
  "",
];

const ButtonWrapper = styled.div`
  width: 170px;
  height: 30px;
  margin-left: auto;
`;

export function ContractManagerList({
  contracts,
  onManagerClick,
}: ContractManagerListProps) {
  const items = contracts.map((contract: Contract) => {
    return (
      <DataListRow flexRatio={flexRatio} key={contract.id}>
        <DataListBodyItem>
          <PdtIcon
            size={40}
            src={contract.pdt.iconPath}
            alt={contract.pdt.name}
          />
        </DataListBodyItem>
        <DataListBodyItem>
          <Tooltip content={contract.manager?.name ?? undefined}>
            <Typography size={2} withEllipsis={true}>
              {contract.manager?.name}
            </Typography>
          </Tooltip>
        </DataListBodyItem>
        <DataListBodyItem>
          <Tooltip content={contract.manager?.department ?? undefined}>
            <Typography size={2} withEllipsis={true}>
              {contract.manager?.department}
            </Typography>
          </Tooltip>
        </DataListBodyItem>
        <DataListBodyItem>
          <Tooltip content={contract.manager?.emailAddress ?? undefined}>
            <Typography size={2} withEllipsis={true}>
              {contract.manager?.emailAddress}
            </Typography>
          </Tooltip>
        </DataListBodyItem>
        <DataListBodyItem>
          <Tooltip content={contract.manager?.welcomeMailSentAt?.toString()}>
            <Typography size={2}>
              {contract.manager?.welcomeMailSentAt?.toString()}
            </Typography>
          </Tooltip>
        </DataListBodyItem>
        <DataListBodyItem>
          {contract.manager && (
            <ButtonWrapper>
              <Button
                buttonType="primary"
                onClick={() => onManagerClick(contract.id)}
              >
                ウェルカムメールの再送
              </Button>
            </ButtonWrapper>
          )}
        </DataListBodyItem>
      </DataListRow>
    );
  });

  return (
    <DataTable>
      <DataListSimpleHeader titles={headerTitles} flexRatio={flexRatio} />
      <DataListBody rows={items} />
    </DataTable>
  );
}
